const animalsData = [
    {
        category: 'animals',
        id: '1',
        alt: '',
        title: '',
        blurhash: 'LVF#jaIpM|%1~UNGRkxaR:n$oJt6',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '2',
        alt: '',
        title: '',
        blurhash: 'LAJj}301n2~9M_%~H?8{4o-oNe9a',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '3',
        alt: '',
        title: '',
        blurhash: 'LkK]iR~AoLR+-nbHjZjZ%1WXNHof',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '4',
        alt: '',
        title: '',
        blurhash: 'LOKJb.~9-P9uxYJ8-ofkxaRjE2of',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '5',
        alt: '',
        title: '',
        blurhash: 'LdM?6r-nR*oL?^ozayj[0.Rlf6a#',
        orientation: 'portrait'
    },
    {
        category: 'animals',
        id: '6',
        alt: '',
        title: '',
        blurhash: 'LFAk]+}G-C}[?Hof$*=}o}I:NagN',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '7',
        alt: '',
        title: '',
        blurhash: 'L3CZ;Z9}01DN00xZ?Zt800RP~AyE',
        orientation: 'landscape'
    },
    {
        category: 'animals',
        id: '8',
        alt: '',
        title: '',
        blurhash: 'LEFE[n00?aM|pf0K-;RjtmIAtRoK',
        orientation: 'portrait'
    }
];

export default animalsData;
